<template>
    <v-textarea
        :label="label"
        :rules="rules"
        :readonly="readonly"
        :disabled="disabled"
        :hide-details="hideDetails"
        :rows="rows"
        :density="density"
    >
        <template v-slot:append-inner>
            <span v-if="activeLangCode" class="fi" :class="[`fi-${useFlagIconCode(activeLangCode)}`]" />
        </template>
    </v-textarea>
</template>

<script setup lang="ts">
    import {useFlagIconCode} from '~/composables/helpers'

    const {
        density = 'comfortable',
        hideDetails = false,
        rows = 3,
    } = defineProps<{
        label?: string
        rules?: any[]
        density?: 'default' | 'comfortable' | 'compact'
        readonly?: boolean
        disabled?: boolean
        hideDetails?: boolean | 'auto'
        rows?: string | number
    }>()

    const activeLangCode = inject('activeLangCode', ref('en'))
</script>
